import siren_mp3 from '../../../zont/app/zont-notification-widget/app/src/main/res/raw/alarm.mp3';
import audio_autostart_on_mp3 from '../../../zont/app/zont-notification-widget/app/src/main/res/raw/third_start.mp3';
import audio_autostart_off_mp3 from '../../../zont/app/zont-notification-widget/app/src/main/res/raw/third_stop.mp3';
import guard_on_mp3 from '../../../zont/app/zont-notification-widget/app/src/main/res/raw/guard_on.mp3';
import guard_off_mp3 from '../../../zont/app/zont-notification-widget/app/src/main/res/raw/guard_off.mp3';
import { isAndroidApp, isIOSApp } from 'utils';
const _audio_cache = {};
const get_audio_by_url = (url) => {
    let audio = _audio_cache[url];
    if (audio) {
        return audio;
    }
    audio = new Audio(url);
    _audio_cache[url] = audio;
    return audio;
};
const last_auto_ignition_time = {};
const what_play = (sound, what) => {
    console.log('what_play', what, sound);
    if (isIOSApp()) {
        //@ts-ignore
        // Need to unescape if path have '%20' component
        const filePath = // @ts-ignore
         (decodeURI(cordova.file.applicationDirectory) + 'www/' + sound).replace('file://', '');
        // @ts-ignore
        const media = new Media(filePath, () => {
            console.log('Media success');
        }, (e) => {
            console.error('Media error', JSON.stringify(e));
        });
        media.setVolume('1.0');
        media.play();
    }
    else if (isAndroidApp()) {
        console.log('try play ZontNotificationWidget', what);
        window.ZontNotificationWidget?.play_sounds((s) => {
            console.log('ZontNotificationWidget success play_sounds', s);
        }, (e) => {
            console.error('ZontNotificationWidget error play_sounds', e);
        }, { sound: what });
    }
    else {
        get_audio_by_url(sound).play()?.then();
    }
};
export const play_ztc_status_audio = (device_id, portname, portvalue, settings) => {
    switch (portname) {
        case 'guard-state':
            if (settings?.guard === true) {
                if (portvalue === 'enabled') {
                    what_play(guard_on_mp3, 'guard_on');
                }
                else {
                    what_play(guard_off_mp3, 'guard_off');
                }
            }
            break;
        case 'auto-ignition':
            if (settings?.auto_start === true)
                last_auto_ignition_time[device_id] = new Date();
            break;
        case 'engine-state': {
            const time = last_auto_ignition_time[device_id];
            if (settings?.auto_start === true &&
                time != null &&
                new Date().getTime() - time.getTime() < 15000) {
                if (portvalue) {
                    what_play(audio_autostart_on_mp3, 'start');
                }
                else {
                    what_play(audio_autostart_off_mp3, 'stop');
                }
            }
            if (settings?.engine === true) {
                if (portvalue) {
                    what_play(audio_autostart_on_mp3, 'start');
                }
                else {
                    what_play(audio_autostart_off_mp3, 'stop');
                }
            }
            break;
        }
        case 'siren':
            if (settings?.siren === true && portvalue) {
                what_play(siren_mp3, 'siren');
            }
            break;
    }
};
